import actions from './actions';

const {
  CHANGE_PASSWORD_BEGIN,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERR,

  RESET_PASSWORD_BEGIN,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERR,

  ADMIN_UPDATE_BEGIN,
  ADMIN_UPDATE_SUCCESS,
  ADMIN_UPDATE_ERR,
} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const resetinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const adminUpdateInitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const CHANGEPASSWORDReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CHANGE_PASSWORD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case CHANGE_PASSWORD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const ADMINUpdateReducer = (state = adminUpdateInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ADMIN_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ADMIN_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case ADMIN_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const RESETPASSWORDReducer = (state = resetinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case RESET_PASSWORD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case RESET_PASSWORD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { CHANGEPASSWORDReducer, RESETPASSWORDReducer, ADMINUpdateReducer };
